module.exports = __webpack_public_path__ + "static/media/xin.cd553933.svg";